<template>
  <div class="login">
    <van-sticky>
      <van-nav-bar title="托管云平台" left-arrow @click-left="goback()" />
    </van-sticky>
    <div class="login_bg">
      <img src="/static/images/login_bg.png" />
      <div class="login_tag">用户登录入口</div>
    </div>
    <div class="login_form">
      <van-form @submit="onSubmit" ref="loginFormRef" :show-error="false">
        <van-cell-group>
          <van-field v-model="userInfo.username" name="用户名" left-icon="contact" placeholder="请输入你的手机号" :rules="[
              { required: true, message: '请输入手机号码' },
              { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' },
            ]" />
          <van-field v-model="userInfo.password" type="password" name="密码" left-icon="lock" placeholder="请输入登录密码" :rules="[{ required: true, message: '请输入登录密码' }]" />
        </van-cell-group>
        <van-radio-group class="m-l10 m-t30" v-model="newvalue">
          <van-radio name="0" @click="isChangeRadio('0')">记住密码</van-radio>
        </van-radio-group>
        <div class="form_btn">
          <van-button color="#195ED7" round block type="primary" native-type="submit" :disabled="isLoading" :loading="isLoading" loading-text="正在登录ing...">
            登录
          </van-button>
          <van-button style="margin-top: 20px" round block icon="wechat" type="primary" native-type="button" @click="wxPayAuthorize">微信登录</van-button>
        </div>
        <div class="form_tag">
          <!-- <a>新用户注册</a> -->
          <router-link to="/login/signIn"> 新用户注册 </router-link>
          <router-link to="/login/forgotPwd"> 忘记密码？ </router-link>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import storage from "@/utils/storage";

import {
  Button,
  NavBar,
  Form,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  Notify,
} from "vant";

export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  data: function() {
    return {
      userInfo: {
        username: "",
        password: "",
        type: 1,
      },
      newvalue: null,
      oldvalue: null,
      isLoading: false,
      codeValue: "",
    };
  },

  //初始化用户账号信息
  created() {
    if (storage.getAccountInfo()) {
      this.userInfo = storage.getAccountInfo();
      this.oldvalue = "0";
      this.newvalue = "0";
    } else {
      this.oldvalue = null;
      this.newvalue = null;
    }
    if (storage.getCode() == "" && this.GetQueryString('code') != null) {
      this.codeValue = this.GetQueryString('code')
      storage.setCode(this.codeValue)
      this.wxPayAuthorize()
    }
    if (storage.getCode() != "" && storage.getCode() != this.GetQueryString('code') && this.GetQueryString('code') != null) {
      this.codeValue = this.GetQueryString('code')
      storage.setCode(this.codeValue)
      this.wxPayAuthorize()
    }

    this.userInfo = localStorage.getItem('isRemberLogin') == 1 ? JSON.parse(localStorage.getItem('loginInfo')):this.userInfo;
  },

  methods: {
    //账号设置-绑定微信号
    wxPayAuthorize() {
      let that = this;
      let appid = "wx011d015cfd81deca";
      if (that.isWeiXin()) {
        const code = that.codeValue;
        if (code == null || code === "") {
          let url = window.location.href;
          url = "https://tgy.1688tg.com/mobile/#/login";
          let reditUrl =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appid +
            "&redirect_uri=" +
            encodeURIComponent(url) +
            "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
          window.location.href = reditUrl;
          console.log(reditUrl);
        }
        that.loginCallbackAPI(code);
      } else {
        that.$Notify({
          type: "danger",
          message: "请使用微信浏览器打开",
        });
      }
    },

    //获取微信回调信息
    loginCallbackAPI(code) {
      console.log(code);
      if(!code) return false;
      var that = this;
      that.$api
        .loginCallbackAPI({
          code: code,
          state: 1,
        })
        .then(function(res) {
          console.log('loginCallbackAPI',res)
          if (res.data.code === 200) {
            storage.setToken("Bearer " + res.data.data.access_token); //设置请求头值
            storage.setUserInfo("Bearer " + res.data.data.access_token); //设置请求头值
            that.$router.push({ path: "/personal/index" });
          } else if (res.data.code === 100 && that.codeValue != "") {
            Notify({ type: "warning", message: res.data.message });
          }
        })
        .catch(function(err) {
          console.log("error",err);
          Notify({ type: "warning", message: JSON.stringify(err)});
        });
    },

    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      console.log(window.location.search) //?id=2
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },

    // 判断是否是微信浏览器
    isWeiXin() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },

    // 改变单选框状态
    isChangeRadio(index) {
      if (index === this.oldvalue) {
        this.oldvalue = null;
        this.newvalue = null;
        localStorage.setItem('isRemberLogin',0)
      } else {
        this.oldvalue = "0";
        localStorage.setItem('isRemberLogin',1)
      }
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //点击提交登录按钮
    onSubmit() {
      var that = this;
      that.isLoading = true;
      localStorage.getItem('isRemberLogin') == 1 && localStorage.setItem('loginInfo',JSON.stringify(that.userInfo));
      localStorage.getItem('isRemberLogin') != 1 && localStorage.removeItem('loginInfo');
      that.$api
        .loginAPI(that.userInfo)
        .then(function(res) {
          if (res.data.code === 200) {
            storage.setToken("Bearer " + res.data.data.access_token); //设置请求头值
            storage.setUserInfo("Bearer " + res.data.data.access_token); //设置请求头值
            //判断用户是否记住密码
            if (that.newvalue != null) {
              storage.setAccountInfo(that.userInfo);
            } else {
              storage.reMoveAccountInfo(that.userInfo);
            }
            if(res.data.data.openid != ''){
              that.$router.push({ path: "/personal/index" });
            }else{
              alert('账号未绑定微信请及时前往绑定保存')
              that.$router.push({ path: "/personal/setting" });
            }
          
            // that.$router.back();
          } else {
            Notify({ type: "warning", message: res.data.message });
          }
          that.isLoading = false;
        })
        .catch(function(err) {
          console.log("error");
          that.isLoading = false;
        });
    },
  },
};

</script>
<style lang="less" scoped>
.login {
  display: flex;
  flex-direction: column;

  .login_bg {
    position: relative;

    img {
      width: 100%;
      margin-top: -100px;
    }

    .login_tag {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 20%;
      left: 0px;
      right: 0px;
      margin-left: auto;
      margin-right: auto;
      font-size: 14px;
      text-align: center;
      color: #fff;
    }
  }

  .login_form {
    padding: 0px 20px;
    height: auto;
    margin-top: 40px;

    .van-radio {
      font-size: 15px;
    }

    .form_tag {
      display: flex;
      justify-content: space-between;
      padding: 0px 20px;
      font-size: 16px;
    }

    .form_btn {
      margin: 30px 16px;
    }

    .van-button--round {
      box-shadow: 0px 5px 10px rgba(25, 94, 215, 0.3);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/login/index.vue